export default __webpack_public_path__ + "static/The_Cotswolds-36dbba2a7aa4dd966b58c601d463ea2a.jpeg";